import React, { Fragment, useState } from "react";

// Antd
import { Modal, Button, Form, message } from "antd";

// Component
import FormGroup from "./FormGroup";

// API
import { externalBaseUrl } from "../utils/constant";

function VegModal({
  onShowModal,
  onHandleCloseModal,
  userId,
  onSetShowTyModal,
  onSetShowModal,
}) {
  const [isVegetarian, setIsVegetarian] = useState("0");
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const formFields = [
    {
      label: "Are you a vegetarian?",
      name: "is_vegetarian",
      type: "radio",
      required: true,
      reqMsg: "Required",
      radioOptions: [
        { radioLabel: "Yes", radioValue: "1" },
        { radioLabel: "No", radioValue: "0" },
      ],
      value: isVegetarian,
      onChange: (e) => {
        setIsVegetarian(e.target.value);
      },
    },
  ];

  const handleCloseConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const handleGoToConfirm = () => {
    onHandleCloseModal();
    setShowConfirmModal(true);
  };

  const onFinish = async () => {
    onHandleCloseModal();
    handleCloseConfirmModal();

    try {
      const res = await fetch(`${externalBaseUrl}/registrations/update`, {
        method: "POST",
        body: JSON.stringify({
          is_vegetarian: isVegetarian,
          uuid: userId,
        }),
        headers: {
          "Content-type": "application/json",
        },
      });
      const data = await res.json();

      if (data.code === 406) throw new Error(data?.message);

      onSetShowTyModal(true);
    } catch (error) {
      message.error(error.message);
    }
  };

  const goBack = () => {
    setShowConfirmModal(false);
    onSetShowModal(true);
  };

  return (
    <>
      <Modal
        title="MIIP 15th Anniversary Dinner 2025 Confirmation"
        centered
        open={onShowModal}
        onOk={onHandleCloseModal}
        onCancel={onHandleCloseModal}
        closeIcon={null}
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            type="primary"
            size="large"
            danger
            // htmlType="submit"
            // form="vegetarianForm"
            key={"submit"}
            onClick={handleGoToConfirm}
          >
            Submit
          </Button>,
        ]}
      >
        <div className="modalBody">
          <p className="m-t-20">
            Dear Participant,
            <br />
            <br />
            Thank you for registering for our upcoming MIIP 15th Anniversary Dinner. To ensure we cater to your preferences, kindly confirm your
            dietary preference below by <strong>17th November, 6pm</strong>:
          </p>
          <br />
          <Form
            layout="vertical"
            name="vegetarianForm"
            id="vegetarianForm"
            onFinish={onFinish}
            autoComplete="off"
          >
            {formFields.map((el, i) => (
              <Fragment key={`form-input-${i}`}>
                <FormGroup item={el} />
              </Fragment>
            ))}
          </Form>
          
          <p>
            Note: The restaurant is <strong>no pork, no lard</strong>
          </p>
          <p>
            Please note: If no confirmation is received by <strong>17th November, 6pm</strong>,
            your meal will default to non-vegetarian. 
            <br />
            <br />
            Thank you, and we look forward to seeing you at the event!
          </p>
        </div>
      </Modal>

      <Modal
        title="Dietary preferences confirmation"
        centered
        open={showConfirmModal}
        onOk={handleCloseConfirmModal}
        onCancel={handleCloseConfirmModal}
        closeIcon={null}
        closable={false}
        maskClosable={false}
        footer={[
          <Button
            type="primary"
            size="large"
            className="bg-error text-error border-error"
            key={"cancel"}
            onClick={goBack}
          >
            Cancel
          </Button>,
          <Button
            type="primary"
            size="large"
            danger
            key={"submitConfirm"}
            onClick={onFinish}
          >
            Confirm
          </Button>,
        ]}
      >
        <div className="modalBody">
          Your dietary preferences is selected as{" "}
          {isVegetarian === "1" ? "Vegetarian" : "Non-vegetarian"}
        </div>
      </Modal>
    </>
  );
}

export default VegModal;
